import { useStaticQuery, graphql } from "gatsby";

const query = graphql`
    query AllPerformers {
            allDatoCmsPerformer {
                edges {
                    node {
                        ...PerformerFields
                    }
                }
            }
    }
`;


export const useAllPerformers = (): Queries.PerformerFieldsFragment[] => {

    const data = useStaticQuery<Queries.AllPerformersQuery>(query);

    return data.allDatoCmsPerformer.edges.map(({ node: performer }) => {
        return performer as Queries.PerformerFieldsFragment;
    });
}